import * as React from 'react';
import { useState } from 'react';
import { useNotify, Notification } from 'react-admin';
import {
  FormControl,
  TextField,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
  Button,
} from '@mui/material';
import { validatePhone } from '../../ultis/regex/Regex';
import { useDispatch, useSelector } from 'react-redux';
import {
  ClearMessageOtp,
  showOtpForgotModal,
  showOtpGgAuthen,
} from '../../redux/creates-action/OtpAction';
import { Link, NavLink } from 'react-router-dom';
import { useEffect } from 'react';
import { verifyPhoneLogin } from '../../services/Login';
import useScript from '../../ultis/helper/useScript';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';

const ForgotPassword = () => {
  const [values, setValues] = useState({
    phone: '',
    isValidatePhone: false,
  });
  const [activeStep, setActiveStep] = useState(0);
  const [authenType, setAuthenType] = useState(null);
  const [message, setMessage] = useState('');

  const notify = useNotify();
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down('md'));
  const dispatch = useDispatch();
  const data = useSelector((state) => state.otp.data);

  useScript('./assest/jquery.min.js');
  useScript('./assest/jquery-ui.js');
  useScript('./assest/bootstrap.min.js');
  useScript('./assest/fontawesome.js');
  useScript('./assest/slick.js');
  useScript('./assest/jquery.nice-select.min.js');
  useScript('./assest/wow.min.js');
  useScript('./assest/plugin.js');
  useScript('./assest/main.js');

  useEffect(() => {
    if (data.next === true) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      notify('Reset password successfully!', { type: 'success' });
    } else {
      setActiveStep(0);
    }
  }, [data.next]);

  useEffect(() => {
    setActiveStep(0);
  }, []);

  useEffect(() => {
    if (data.notify !== '') {
      setMessage(data.notify);
    }
  }, [data.notify]);

  useEffect(() => {
    if (message !== '') {
      notify(message, { type: data.style });
      dispatch(ClearMessageOtp());
      setMessage('');
    }
  }, [message]);

  const handleNext = (e) => {
    e.preventDefault();

    const data = {
      phone: values.phone,
    };
    if (values.phone !== '' && values.isValidatePhone === true) {
      verifyPhoneLogin(data)
        .then((result) => {
          if (result !== null) {
            setAuthenType(result.authentype);
            if (result.authentype === 1) {
              dispatch(showOtpForgotModal(values.phone, 'SHOW_OTP_FORGOT'));
            } else {
              dispatch(
                showOtpGgAuthen(values.phone, authenType, 'SHOW_OTP_FORGOT')
              );
            }
          }
        })
        .catch((err) => {
          const response = JSON.parse(JSON.stringify(err.response));
          const errors = response.errors;
          let errorMessage = '';
          errors.map((error) => {
            errorMessage += error.message;
            return error;
          });
          if (errors[0].code === 'BAD_USER_INPUT') {
            notify(errorMessage, { type: 'error' });
          } else {
            notify('An error occurred, Please try later!', { type: 'error' });
          }
        });
    } else if (values.isValidatePhone === false) {
      notify('Error Phone Number Format', { type: 'warning' });
    }
  };

  const handleChangePhoneNumber = (e) => {
    let value = e.target.value;
    handleValidatePhone(value);
  };
  function handleValidatePhone(phone) {
    let result = validatePhone(phone);
    let data;
    if (!result) {
      data = { ...values, phone: phone, isValidatePhone: false };
      setValues(data);
      setAuthenType(null);
    } else {
      data = { ...values, phone: phone, isValidatePhone: true };
      setValues(data);
    }
    return data;
  }

  return (
    <div>
      <header className="header-section register login">
        <div className="overlay">
          <div className="container">
            <div className="row d-flex header-area">
              <nav className="navbar d-flex justify-content-between navbar-expand-lg navbar-dark">
                <Link
                  className="navbar-brand"
                  to="/"
                  style={{
                    fontWeight: 600,
                    fontSize: '24px',
                    color: '#1a4dbe',
                  }}
                >
                  <span className="logo-home" />
                  APO
                  <span
                    style={{
                      fontWeight: 600,
                      fontSize: '24px',
                      color: '#055c2d',
                    }}
                  >
                    LLO
                  </span>
                </Link>
                <div className="d-flex align-items-center justify-content-end">
                  <ul className="navbar-nav">
                    <li className="nav-item">Don't have an account</li>
                  </ul>
                  <div className="right-area header-action d-flex align-items-center">
                    <Link to="/signup" className="cmn-btn">
                      Register
                    </Link>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </header>
      <section className="sign-in-up login" style={{ paddingTop: '0px' }}>
        <div className="overlay  pb-120">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="form-content">
                  <div className="section-header" style={{}}></div>
                  <Grid
                    container
                    direction="column"
                    alignItems="center"
                    sx={{ justifyContent: 'center' }}
                  >
                    <Grid item>
                      {activeStep === 0 ? (
                        <>
                          <React.Fragment>
                            <Grid item xs={12}>
                              <Grid>
                                <Typography
                                  variant="h5"
                                  sx={{
                                    textAlign: 'center',
                                    mb: `${matchDownMD ? '8px' : '16px'}`,
                                    fontWeight: 'bold',
                                    fontSize: `${matchDownMD ? '24px' : '34px'
                                      }`,
                                  }}
                                >
                                  Forgot Your Password!
                                </Typography>
                              </Grid>
                              <Grid container>
                                <Grid item xs={12}></Grid>
                                <Grid item xs={12}>
                                  <Typography
                                    variant="body1"
                                    sx={{
                                      textAlign: 'center',
                                      color: '#637381',
                                    }}
                                  >
                                    Please enter your phone number with your
                                    account
                                  </Typography>
                                </Grid>
                              </Grid>
                              <Grid container>
                                <Grid item xs={12}>
                                  <Typography
                                    variant="body1"
                                    sx={{
                                      textAlign: 'center',
                                      mb: `${matchDownMD ? '6px' : '24px'}`,
                                      color: '#637381',
                                    }}
                                  >
                                  </Typography>
                                </Grid>
                              </Grid>
                              <div>
                                <FormControl fullWidth>
                                  <Grid container spacing={2}>
                                    <Grid container item>
                                      <Grid item xs={12} sx={{ mb: 2 }}>
                                        <TextField
                                          id="outlined-basic"
                                          label="Phone"
                                          required
                                          name="phone"
                                          value={values.phone}
                                          type="phone"
                                          size="large"
                                          onChange={handleChangePhoneNumber}
                                          fullWidth
                                        />
                                      </Grid>
                                    </Grid>
                                    <Grid container item>
                                      <Grid item xs={12}>
                                        <div
                                          className="btn-area d-flex align-items-center justify-content-center"
                                          style={{ marginBottom: '16px' }}
                                        >
                                          <button
                                            className="cmn-btn"
                                            onClick={handleNext}
                                            style={{
                                              fontSize: '20px',
                                              textAlign: 'center',
                                            }}
                                          >
                                            Send Request
                                          </button>
                                        </div>
                                      </Grid>
                                    </Grid>
                                    <Grid container item>
                                      <Grid item xs={12}>
                                        <div
                                          className="d-flex align-items-center justify-content-center"
                                          style={{ marginBottom: '16px' }}
                                        >
                                          <Link
                                            to="/login"
                                            className="text second"
                                            style={{ color: '#000' }}
                                          >
                                            Back to login
                                          </Link>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </FormControl>
                                <Notification />
                              </div>
                            </Grid>
                          </React.Fragment>
                        </>
                      ) : (
                        <>
                          <Grid item xs={12}>
                            <Grid>
                              <Typography
                                variant="h5"
                                sx={{
                                  textAlign: 'center',
                                  mb: `${matchDownMD ? '8px' : '16px'}`,
                                  fontWeight: 'bold',
                                  fontSize: `${matchDownMD ? '24px' : '30px'}`,
                                }}
                              >
                                Reset Password Successful!!
                              </Typography>
                            </Grid>
                            <Grid container>
                              <Grid item xs={12}>
                                <Typography
                                  variant="body1"
                                  sx={{
                                    textAlign: 'center',
                                    color: '#637381',
                                    mb: `${matchDownMD ? '6px' : '8px'}`,
                                  }}
                                >
                                  Please go back to login to reset password
                                  again!
                                </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <div
                                  className="d-flex align-items-center justify-content-center"
                                  style={{ marginBottom: '16px' }}
                                >
                                  <Button
                                    component={NavLink}
                                    startIcon={<KeyboardReturnIcon></KeyboardReturnIcon>}
                                    variant="contained"
                                    to="/login"
                                    className="text second"
                                  >
                                    Back to login
                                  </Button>
                                </div>
                              </Grid>
                            </Grid>
                          </Grid>
                        </>
                      )}
                      <Notification />
                    </Grid>
                  </Grid>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ForgotPassword;
